import { render, staticRenderFns } from "./EodSpreadSetting.vue?vue&type=template&id=37645894&"
import script from "./EodSpreadSetting.vue?vue&type=script&lang=js&"
export * from "./EodSpreadSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports